import {combineReducers} from 'redux';
import FormBuiderReducers from './view/formulario/actions/FormBuilderReducers';
import MySubscriptionsReducers from './view/inicio/acoes/MySubscriptionsReducers';
import FormBuilderGRUReducer from './view/gru/actions/FormBuilderGRUReducer';
import auth from './auth/AuthReducers'

const rootReducer = combineReducers({
    FormBuiderReducers,
    MySubscriptionsReducers,
    FormBuilderGRUReducer,
    auth
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/reducers.js